module.exports = __webpack_public_path__ + "img/login_logo.a9fc3414.png";